<!-- Desktop Menu -->
<div class="app-menu govuk-desktop-menu">
	<div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('our-ceremony') }"
			data-module="govuk-button"
			(click)="navigateTo('our-ceremony')"
		>
			<i class="ph ph-bold ph-calendar-dots" aria-hidden="true"></i> My Ceremony
		</button>
	</div>
	<div>
		<button *ngIf="canViewAddOns && canPurchaseAddons"
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('optional-add-ons') }"
			data-module="govuk-button"
			(click)="navigateTo('optional-add-ons')"
		>
			<i class="ph ph-bold ph-sparkle" aria-hidden="true"></i> Optional Add-ons
		</button>
	</div>
	<div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('ceremony-checklist') }"
			data-module="govuk-button"
			(click)="navigateTo('ceremony-checklist')"
		>
			<i class="ph ph-bold ph-calendar-check" aria-hidden="true"></i>Ceremony Checklist
		</button>
	</div>
	<!-- <div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('ceremony-enhancements') }"
			data-module="govuk-button"
			(click)="navigateTo('ceremony-enhancements')"
		>
			<i class="ph ph-bold ph-sparkle" aria-hidden="true"></i> Ceremony Enhancements
		</button>
		@let categories = categories$ | async;
		@if(categories?.length > 0) {
			<ul class="sub-menu">
				@for(category of categories; track $index) {
					<li>
						<button
						tabindex="0"
						class="sub-menu-item"
						[ngClass]="{
							active: isActive('ceremony-enhancements', category.value)
						}"
						(click)="
							navigateTo('ceremony-enhancements', { category: category.value });
							$event.preventDefault()
						"
						(keyup.enter)="
							navigateTo('ceremony-enhancements', { category: category.value })
						"
					>
						{{category.title}}
					</button>
					</li>
				}
			</ul>
		}
		
	</div> -->
	<div *ngIf="!excludedChoicesServiceIds.includes(service?.global_id)">
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('ceremony-choices') }"
			data-module="govuk-button"
			(click)="navigateTo('ceremony-choices')"
		>
			<i class="ph ph-bold ph-list-bullets" aria-hidden="true"></i> Ceremony Choices
		</button>
	</div>
	<div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('payment-information') }"
			data-module="payment-information"
			(click)="navigateTo('payment-information')"
		>
			<i class="ph ph-bold ph-wallet" aria-hidden="true"></i>Payment Information
		</button>
	</div>
	<div *ngIf="showGiveNotice">
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('give-notice') }"
			data-module="govuk-button"
			(click)="navigateTo('give-notice')"
		>
			<i class="ph ph-bold ph-bell" aria-hidden="true"></i> Give Notice
		</button>
	</div>

	<div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('ceremony-discussion') }"
			data-module="govuk-button"
			(click)="navigateTo('ceremony-discussion')"
		>
			<i class="ph ph-bold ph-chat-circle-dots" aria-hidden="true"></i> Ceremony Discussion
		</button>
	</div>

	<div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('terms-and-conditions') }"
			data-module="govuk-button"
			(click)="navigateTo('terms-and-conditions')"
		>
			<i class="ph ph-bold ph-article" aria-hidden="true"></i> Terms & Conditions
		</button>
	</div>
	<div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('faqs') }"
			data-module="govuk-button"
			(click)="navigateTo('faqs')"
		>
			<i class="ph ph-bold ph-question" aria-hidden="true"></i>FAQs
		</button>
	</div>
	<div>
		<button
			type="button"
			class="govuk-button govbook-button"
			[ngClass]="{ active: isActive('communication') }"
			data-module="govuk-button"
			(click)="navigateTo('communication')"
		>
			<i class="ph ph-bold ph-envelope" aria-hidden="true"></i>Contact Us / Messages
		</button>
	</div>
	<div class="mt-auto">
		<button
			type="button"
			class="govuk-button govbook-button signout mt-auto"
			data-module="govuk-button"
			(click)="signOut()"
		>
			<i class="ph ph-bold ph-sign-out" aria-hidden="true"></i>Sign out
		</button>
	</div>
</div>

<!-- Mobile Menu -->
<div
	class="govuk-service-navigation govuk-mobile-menu"
	data-module="govuk-service-navigation"
>
	<div class="govuk-width-container">
		<div class="govuk-service-navigation__container">
			<nav aria-label="Menu" class="govuk-service-navigation__wrapper">
				<button
					type="button"
					class="govuk-service-navigation__toggle govbook-mobile-menu--inverse govuk-js-service-navigation-toggle"
					aria-controls="navigation"
					(click)="toggleMenu()"
				>
					Menu
				</button>
				<ul
					class="govuk-service-navigation__list govbook-mobile-menu--inverse"
					id="navigation"
					[ngClass]="{ 'govuk-service-navigation__list--open': isMenuOpen }"
					*ngIf="isMenuOpen"
				>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('our-ceremony')"
						>
							My Ceremony
						</a>
					</li>
					<li
						class="govuk-service-navigation__item"
						*ngIf="canViewAddOns && canPurchaseAddons"
					>
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('optional-add-ons')"
						>
							Optional Add-ons
						</a>
					</li>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('ceremony-checklist')"
						>
							Ceremony Checklist
						</a>
					</li>
					<li
						class="govuk-service-navigation__item"
						*ngIf="!excludedChoicesServiceIds.includes(service?.global_id)"
					>
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('ceremony-choices')"
						>
							Ceremony Choices
						</a>
					</li>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('payment-information')"
						>
							Payment Information
						</a>
					</li>
					<li class="govuk-service-navigation__item" *ngIf="showGiveNotice">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('give-notice')"
						>
							Give Notice
						</a>
					</li>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('ceremony-discussion')"
						>
							Ceremony Discussion
						</a>
					</li>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('terms-and-conditions')"
						>
							Terms & Conditions
						</a>
					</li>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('faqs')"
						>
							FAQs
						</a>
					</li>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="navigateTo('communication')"
						>
							Contact Us / Messages
						</a>
					</li>
					<li class="govuk-service-navigation__item">
						<a
							class="govuk-service-navigation__link"
							(click)="signOut()"
						>
							Sign out
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</div>
